import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Label } from 'images/latest'

const LabelIcon = () => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56' }}
    SVG={Label}
  />
)

export default LabelIcon
